import { createSelector } from 'reselect'

const getUserData = state => state.user

const userIsLoggedInSelector = createSelector(
	[ getUserData ],
	userState => userState.logged
)

export default userIsLoggedInSelector
